import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await http.post("/leads", payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await http.post("/admin/login", { password });
  return data;
}

export async function listLeads(password) {
  const { data } = await http.get("/admin/leads", {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function logEmailEnquiry(query_id) {
  // Fire-and-forget persistence; never blocks the mailto flow.
  try {
    const { data } = await http.post("/email-enquiry", {
      query_id,
      source: "email-float",
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 400) : "",
    });
    return data;
  } catch (err) {
    // silently swallow — mailto still works client-side
    console.warn("Query ID persistence failed (non-blocking):", err?.message);
    return null;
  }
}

export const CONTACT = {
  phone: "+4915208542673",
  whatsapp: "4915208542673",
  email: "sales@zopran.com",
  address: "FRA HUB, Behringstr. 6B, 64291 Darmstadt, Germany",
  linkedin:
    "https://www.linkedin.com/in/ozan-direnc-k%C3%B6se-24aa22277",
  brands: [
    { name: "zopran.com", url: "https://www.zopran.com" },
    { name: "aeroship-global.com", url: "https://www.aeroship-global.com" },
    { name: "shipmyparcels.com", url: "https://www.shipmyparcels.com" },
  ],
};
